import { RolloutRestartType } from "utils/saastypes";
import { CLUSTER_DETAIL_URL } from "utils/routePaths";

export const INTEGER_AT_LEAST_ONE_NUMBER = "^[0-9]+$";

export const rolloutRestartResourceBaseTypes = [
  {
    name: "Conductor Server",
    value: RolloutRestartType.CONDUCTOR,
  },
  {
    name: "Conductor Workers",
    value: RolloutRestartType.WORKERS,
  },
  {
    name: "Orkes Agent",
    value: RolloutRestartType.AGENT,
  },
];

export const contextFlagOptions = [
  { name: "None", value: "N" },
  { name: "Before -B", value: "B" },
  { name: "After -A", value: "A" },
  { name: "Context -C", value: "C" },
];
export const fetchOptions = [
  { name: "Last (tail)", value: "tail" },
  { name: "First (head)", value: "head" },
];

export const CLUSTER_DETAILS_TABS = {
  DETAILS: "Details",
  URLS: "URLs",
  STATUS: "Status",
  NETWORK: "Network",
  PERSISTENCE: "Persistence",
  PROPERTIES: "Application Properties",
  RESOURCES: "Resources",
  AUTHENTICATION: "Authentication",
  HISTORY: "Actions History",
  PODS: "Pods",
  RELEASES: "Releases",
  CERTIFICATE: "Certificates",
  INFRASTRUCTURE: "Infrastructure",
};

export const DETAILS_TAB_ID = "details";
// Worker hosting (CLOUD-1193) has no Conductor server, Postgres, Redis, TLS certificate or
// authentication config of its own, so PERSISTENCE, PROPERTIES, AUTHENTICATION and
// CERTIFICATE would all render empty. Everything else applies: health, worker/agent pods,
// agent-issued actions, version reporting, the VNet/subnet the workers run in, and RESOURCES
// (where worker sizing is inspected and adjusted).
//
// Lives here rather than in ClusterDetailsLegacy so workerHostingTabs.test.ts can assert it
// without dragging the whole component tree into jsdom. The rendered result is covered by
// tests/workerHostingScreens.spec.ts, but Playwright is not part of the portal CI job (which runs
// prettier:check and yarn test), so this allowlist is what a CI run can actually check.
export const WORKER_HOSTING_TABS = [
  DETAILS_TAB_ID,
  // URLS is deliberately absent. A worker environment publishes no endpoint: nothing in the
  // control plane ever creates a URL row for one, so the tab could only ever render empty.
  // getClusterUrls only builds ConductorUIURL and ConductorSwaggerURL, and neither exists here.
  CLUSTER_DETAIL_URL.STATUS,
  CLUSTER_DETAIL_URL.NETWORK,
  CLUSTER_DETAIL_URL.RESOURCES,
  CLUSTER_DETAIL_URL.HISTORY,
  CLUSTER_DETAIL_URL.PODS,
  CLUSTER_DETAIL_URL.RELEASES,
];
